<template>
  <div ref="containerRef" class="animacion-elegante">
    <!-- Foto principal a todo lo ancho -->
    <img
      ref="fotoRef"
      src="@/assets/ovalada1.webp"
      alt="Foto destacada"
      class="foto-elegante-full"
    />

    <!-- Foto secundaria con inclinación opuesta -->
  
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'AnimacionFotoPrincipal',
  setup() {
    const containerRef = ref(null)
    const fotoRef = ref(null)
    const foto2Ref = ref(null)

    const animate = () => {
      const tl = gsap.timeline()

      // Foto principal (entrada desde abajo con inclinación)
      tl.fromTo(
        fotoRef.value,
        { y: 150, opacity: 0, rotate: -6, scale: 0.95 },
        { y: 0, opacity: 1, rotate: 0, scale: 1, duration: 1.4, ease: 'power3.out' }
      )

      // Foto secundaria
      .fromTo(
        foto2Ref.value,
        { y: 150, opacity: 0, rotate: 6, scale: 0.95 },
        { y: 0, opacity: 1, rotate: 0, scale: 1, duration: 1.4, ease: 'power3.out' },
        '-=1'
      )
    }

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.2 })

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      fotoRef,
      foto2Ref
    }
  }
}
</script>

<style scoped>
.animacion-elegante {
  position: relative;
  width: 100%;
    visibility: visible;

  padding: 0px 0;
  display: flex;
  margin-top:-50px;

  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.foto-elegante-full {
  width: 100%;
  max-width: 100%;
  margin-bottom: 40px;
  opacity: 0;
}

.foto-elegante-reversa {
  width: 90%;
  max-width: 600px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  transform: rotate(3deg);
  opacity: 0;
}
</style>
